import { Injectable } from '@angular/core';
import { HttpClient, HttpParams,  HttpHeaders } from '@angular/common/http';
import { HttpErrorHandler, HandleError } from '../common/http-error-handler.service';
import { httpOptions } from '../common/common.service';
import { of } from 'rxjs';
import { map, startWith, catchError } from 'rxjs/operators';
import { Observable, switchMap } from 'rxjs';
import { bearerToken } from '../common/auth.service';
import { urls as apis } from '../apiUrls';


import { DownloadAnnualgradeRequestDataModel, DownloadAnnualgradesDataModel } from '../../models/DownloadData/DownloadAnnualgradesData';
import { DownloadLabResultsDataModel, DownloadLabResultsRequestModel } from '../../models/DownloadData/DownloadLabResultsData';
import { DownloadDataError } from 'src/app/models/DownloadData/DownloadDataError';
import { cloneDeep } from 'lodash';



@Injectable()
export class DownloadDataService {	

	private handleError: HandleError;

	constructor(private http: HttpClient, httpErrorHandler: HttpErrorHandler) {
		this.handleError = httpErrorHandler.createHandleError('DownloadDataServicee');
	}

	getAnnualgradesDataCount(payload : DownloadAnnualgradeRequestDataModel) : Observable<number> {
		return this.http
			.post(apis.downloadDataAnnualgradesCount, payload, httpOptions)
			.pipe(
				map((data : any) => {
					return data;
				}),				
				catchError(this.handleError('getAnnualgradesDataCount', 0))
			);
	}

	downloadAnnualgradesData(payload : DownloadAnnualgradeRequestDataModel, asTextOrCSV? : boolean) : Observable<DownloadAnnualgradesDataModel[] | any> {
		let options : any = httpOptions;
		if(options && asTextOrCSV)
		{
			options = {   
				headers : new HttpHeaders({
					"Content-Type": "application/json",
					"Accept": "text/csv"					
				}),
				responseType : "text"
			}
		}

		return this.http
			.post(apis.downloadDataAnnualgrades, payload, options)
			.pipe(
				map((data : any) => {					
					return data;				
				}),
				catchError((error) => { 
					return of(<DownloadDataError>error); 
				})
			);
	}

	getLabResultsDataCount(payload : DownloadLabResultsRequestModel) : Observable<number> {
		return this.http
			.post(apis.downloadDataLabResultsCount, payload, httpOptions)
			.pipe(
				map((data : any) => {
					return data;
				}),				
				catchError(this.handleError('getLabResultsDataCount', 0))
			);
	}

    downloadLabResultsData(payload : DownloadLabResultsRequestModel, asTextOrCSV? : boolean): Observable<DownloadLabResultsDataModel[] | any> | any {
		let options : any = httpOptions;
		if(options && asTextOrCSV)
		{
			options = {   
				headers : new HttpHeaders({
					"Content-Type": "application/json",
					"Accept": "text/csv"
					
				}),
				responseType : "text"
			}
		}
		return this.http
			.post(apis.downloadDataLabResults, payload, options)
			.pipe(
				map((data : any) => {
					return data;					
				}),
				catchError((error) =>  { 
					return of(error); 
				})
			);
	}
}
